module.exports = __webpack_public_path__ + "22dcfaadffc8bf8270977a51b123cfd6.svg";